import React from 'react';
import { FaHeadphones, FaLightbulb, FaClipboardCheck } from 'react-icons/fa';

const TYPE_CONFIG = {
    episode: {
        icon: <FaHeadphones size={10} />,
        label: 'Episode',
        className: 'tag-chip--episode',
    },
    key_takeaway: {
        icon: <FaLightbulb size={10} />,
        label: 'Takeaway',
        className: 'tag-chip--takeaway',
    },
    practice: {
        icon: <FaClipboardCheck size={10} />,
        label: 'Practice',
        className: 'tag-chip--practice',
    },
};

/**
 * TagChip — compact pill that represents a tagged club element inside a message.
 *
 * Props:
 *   type         'episode' | 'key_takeaway' | 'practice'
 *   displayText  string – item title snapshot
 *   guid         string – taggable_guid for navigation
 *   onClick      (type, guid) => void  (optional)
 *   removable    bool – shows × button (used inside ChatInput)
 *   onRemove     () => void
 */
export default function TagChip({ type, displayText, guid, onClick, removable = false, onRemove }) {
    const config = TYPE_CONFIG[type] ?? TYPE_CONFIG.episode;

    const handleClick = () => {
        if (onClick) onClick(type, guid);
    };

    return (
        <span
            className={`tag-chip ${config.className} ${onClick ? 'tag-chip--clickable' : ''}`}
            onClick={handleClick}
            title={`${config.label}: ${displayText}`}
        >
            <span className="tag-chip__icon">{config.icon}</span>
            <span className="tag-chip__label">{config.label}</span>
            <span className="tag-chip__text">{displayText}</span>
            {removable && (
                <button
                    className="tag-chip__remove"
                    onClick={(e) => { e.stopPropagation(); onRemove && onRemove(); }}
                    aria-label="Remove tag"
                >
                    ×
                </button>
            )}
        </span>
    );
}
